export default __webpack_public_path__ + "static/media/PiramideClosed.8f23f7e0.jpg";